import { api } from '@/api/client'

export async function getSiteSettings() {
  const { data } = await api.get('/settings')
  return data
}

export async function updateSiteSettings(payload) {
  const { data } = await api.patch('/settings', payload)
  return data
}

export async function getBackupStatus() {
  const { data } = await api.get('/settings/backups')
  return data
}

export async function runBackup() {
  const { data } = await api.post('/settings/backups/run')
  return data
}

export async function getAiSettings() {
  const { data } = await api.get('/settings/ai')
  return data
}

/** Provider/model/configured — safe for any signed-in user. */
export async function getAiStatus() {
  const { data } = await api.get('/settings/ai/status')
  return data
}

export async function updateAiSettings(payload) {
  const { data } = await api.patch('/settings/ai', payload)
  return data
}

export async function aiSearch(body) {
  const { data } = await api.post('/settings/ai/search', body, { timeout: 120000 })
  return data
}

export async function listExpiries() {
  const { data } = await api.get('/expiries')
  return data
}

export async function getTelegramSettings() {
  const { data } = await api.get('/settings/telegram')
  return data
}

export async function updateTelegramSettings(payload) {
  const { data } = await api.patch('/settings/telegram', payload)
  return data
}

export async function linkTelegramChat() {
  const { data } = await api.post('/settings/telegram/link-chat')
  return data
}

export async function sendTelegramTest() {
  const { data } = await api.post('/settings/telegram/send-test')
  return data
}

export async function enableTelegramWebhook() {
  const { data } = await api.post('/settings/telegram/enable-webhook')
  return data
}

export async function disableTelegramWebhook() {
  const { data } = await api.post('/settings/telegram/disable-webhook')
  return data
}
